import BigNumber from 'bignumber.js'
import { useMemo } from 'react'
import { useTokenUsdPrices } from 'state/app/hooks'
import { useBalanceSelect } from './useBalanceSelect'

export const useTotalBalanceInUsd = () => {
  const { balanceOptions } = useBalanceSelect(null)
  const prices = useTokenUsdPrices()

  return useMemo(() => {
    return balanceOptions?.reduce((prev, curr) => {
      return prev.plus(curr.balance.amount.times(prices[curr.balance.token.code]))
    }, new BigNumber(0))
  }, [balanceOptions, prices])
}
